import cn from 'classnames';
import moment from 'moment';
import {FC, useState} from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import CountDownTimer from '../../../CountDownTimer';
import './styles.scss';

const getDatesDiff = (start: moment.Moment, end: moment.Moment) => {
  return end.diff(start);
};

interface TimerProps {
  selectedRaceTab: Record<string, string | number>;
}

const Timer:FC<TimerProps> = ({selectedRaceTab}) => {
  const { t } = useTranslation();

  const [isExpired, setIsExpired] = useState(moment(selectedRaceTab?.expire_time).isBefore(moment()));

  const classes = cn('race-tab-timer', {
    'race-tab-timer--mobile': isMobile,
  });

  if (moment(selectedRaceTab?.expire_time).isBefore(moment())) return null;

  return (
      <div className={classes}>
        {isExpired ? (
            <div className={`race-tab-timer__progress-bar `}>
          <span
              style={{
                width:
                    selectedRaceTab?.status === 'completed'
                        ? '100%'
                        : `${
                            (getDatesDiff(moment(selectedRaceTab?.start_time), moment()) * 100) /
                            getDatesDiff(moment(selectedRaceTab?.start_time), moment(selectedRaceTab?.expire_time))
                        }%`,
              }}
          ></span>
            </div>
        ) : (
            <div className="race-tab-timer__wrapper">
          <span className="end-date-widget-wrapper__time">
            <span className="race-tab-timer__title">{t('endsIn')}:</span>
            <CountDownTimer
                countdownTimestampMs={selectedRaceTab?.expire_time as number}
                withoutLabels={true}
                withDots={true}
                withSkeleton={true}
                onFinish={() => setIsExpired(true)}
            />
          </span>
            </div>
        )}
      </div>
  );
};

export default Timer;
